//Actions
//COMPANIES_HOUSE_UK_SEARCH_COMPANIES
import {
  COMPANIES_HOUSE_UK_SEARCH_COMPANIES,
  COMPANIES_HOUSE_UK_SEARCH_COMPANIES_SUCCESS,
  COMPANIES_HOUSE_UK_SEARCH_COMPANIES_FAILURE,
  COMPANIES_HOUSE_UK_GET_FILING_HISTORY,
  COMPANIES_HOUSE_UK_GET_FILING_HISTORY_SUCCESS,
  COMPANIES_HOUSE_UK_GET_FILING_HISTORY_FAILURE,
  COMPANIES_HOUSE_UK_GET_OFFICERS,
  COMPANIES_HOUSE_UK_GET_OFFICERS_SUCCESS,
  COMPANIES_HOUSE_UK_GET_OFFICERS_FAILURE,
} from "./actionType";

export const companiesHouseGovUKSearchCompanies = (payload) => ({
  type: COMPANIES_HOUSE_UK_SEARCH_COMPANIES,
  payload,
});

export const companiesHouseGovUKSearchCompaniesSuccess = (payload) => ({
  type: COMPANIES_HOUSE_UK_SEARCH_COMPANIES_SUCCESS,
  payload,
});

export const companiesHouseGovUKSearchCompaniesFailure = (payload) => ({
  type: COMPANIES_HOUSE_UK_SEARCH_COMPANIES_FAILURE,
  payload,
});

//COMPANIES_HOUSE_UK_GET_FILING_HISTORY
export const companiesHouseGovUKGetFilingHistory = (payload) => ({
  type: COMPANIES_HOUSE_UK_GET_FILING_HISTORY,
  payload,
});

export const companiesHouseGovUKGetFilingHistorySuccess = (payload) => ({
  type: COMPANIES_HOUSE_UK_GET_FILING_HISTORY_SUCCESS,
  payload,
});

export const companiesHouseGovUKGetFilingHistoryFailure = (payload) => ({
  type: COMPANIES_HOUSE_UK_GET_FILING_HISTORY_FAILURE,
  payload,
});

//COMPANIES_HOUSE_UK_GET_OFFICERS
export const companiesHouseGovUKGetOfficers = (payload) => ({
  type: COMPANIES_HOUSE_UK_GET_OFFICERS,
  payload,
});

export const companiesHouseGovUKGetOfficersSuccess = (payload) => ({
  type: COMPANIES_HOUSE_UK_GET_OFFICERS_SUCCESS,
  payload,
});

export const companiesHouseGovUKGetOfficersFailure = (payload) => ({
  type: COMPANIES_HOUSE_UK_GET_OFFICERS_FAILURE,
  payload,
});
